var exports = {
  "kL": "SwitchGroup.module__container___anhZdk",
  "AS": "SwitchGroup.module__item___anhZdk",
  "Ly": "SwitchGroup.module__itemContent___anhZdk",
  "IR": "SwitchGroup.module__itemLabel___anhZdk",
  "a": "SwitchGroup.module__itemLabelInteractive___anhZdk",
  "r9": "SwitchGroup.module__disabled___anhZdk",
  "QK": "SwitchGroup.module__labelText___anhZdk",
  "LE": "SwitchGroup.module__shortcut___anhZdk",
  "ce": "SwitchGroup.module__extraContent___anhZdk",
};

module.exports = exports;
